export default "__VITE_ASSET__CZSUk7Ch__"